import { apiClient } from '@/utils/api-client';
import type { ApiKeyResource } from '@/types/external-api-keys';

interface RevokeProximaKeysResponse {
  data: { revoked_count: number };
}

export async function countApiKeysForProjects(organizationId: number | string): Promise<number> {
  const response = await apiClient.get<{ data: ApiKeyResource[] }>(
    '/api/external_api/proxima_keys',
    { organization_id: organizationId, key_type: 'project' }
  );
  return response.data?.length ?? 0;
}

export async function revokeProximaApiKeysByOrganization(
  organizationId: string | number
): Promise<RevokeProximaKeysResponse> {
  return apiClient.delete<RevokeProximaKeysResponse>(
    '/api/external_api/proxima_keys',
    { organization_id: Number(organizationId) }
  );
}

export async function revokeProximaApiKeysById(
  ids: number[],
  organization_id: number,
  key_type: 'organization' | 'project'
): Promise<RevokeProximaKeysResponse> {
  return apiClient.delete<RevokeProximaKeysResponse>(
    '/api/external_api/proxima_keys',
    { ids, organization_id, key_type }
  );
}
